import { type Context, useContext } from 'react';
import { type RadioGroupState } from 'react-stately';

export const useRadioState = (RadioContext: Context<RadioGroupState | null>) => {
    const state = useContext(RadioContext);

    if (!state) {
        throw new Error('Hook useRadioState is used outside of RadioContext');
    }

    return state;
};
